import { render, staticRenderFns } from "./AvatarSlider.vue?vue&type=template&id=f925c86e&"
import script from "./AvatarSlider.vue?vue&type=script&lang=js&"
export * from "./AvatarSlider.vue?vue&type=script&lang=js&"
import style0 from "./AvatarSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports